// tslint:disable

import { AnalyticsConfigurationKeys } from './analytics-rules';
import { BestPerformingDashboardSettings } from './models/best-performing-dashboard-settings';

export const defaultBestPerformingDashboard: BestPerformingDashboardSettings = {
  hideBetaIndicator: false,
  showUserMenuItem: false,
  dashboards: {
    lists: {
      enabled: false,
      brandOrgFilter: {
        enabled: false,
        selectFromAccountByDefault: false,
      },
      preselectedDateRangeFilterValue: 'last30days',
    },
  },
};

export const AnalyticsConfiguration = {
  [AnalyticsConfigurationKeys.BestPerformingDashboard]: JSON.stringify(
    defaultBestPerformingDashboard,
  ),
  [AnalyticsConfigurationKeys.EnableListAnalytics]: false,
  [AnalyticsConfigurationKeys.ProductIdFormat]: ['materialId'],
};
